// extracted by mini-css-extract-plugin
export default {"container":"container__xq9-Z","img":"img__uBL3+","message":"message__fLw02","actions":"actions__CdO5r"};